import { BASE_URL_API } from "../../constants";
import { useAuthStore } from "../../stores/useAuthStore";
import fetcher from "../../utils/fetcher";

export const getDocument = async () => {
    return fetcher(BASE_URL_API + "/document/all", {
        method: "GET",
        credentials: "include",
    });
};

export const _api_download_multiple_documents = async ({
    items = "",
    document_type = "",
}) => {
    const user = useAuthStore.getState().infos;
    try {
        const response = await fetch(
            `${BASE_URL_API}/documents/${document_type}/files/batch-download${items}`,
            {
                headers: {
                    Authorization: `Bearer ${user?.access}`,
                },
                method: "GET",
                credentials: "include",
            }
        );

        if (!response.ok) {
            const res = await response.json();
            return {
                success: false,
                message: res.message,
            };
        }

        // Vérifiez si les headers sont présents
        const contentDisposition =
            response.headers.get("Content-Disposition") ||
            response.headers.get("content-disposition");

        // if (!contentDisposition) {
        //     throw new Error("Content-Disposition header is missing");
        // }
        // Extract filename from Content-Disposition header
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);

        let filename = "document.zip"; // Default filename
        if (matches != null && matches[1]) {
            filename = matches[1].replace(/['"]/g, "");
        }

        const blob = await response.blob();

        let a = document.createElement("a");
        if (window.URL && window.URL.createObjectURL) {
            let objectUrl = window.URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(objectUrl);
            return {
                success: true,
            };
        } else {
            // Fallback for browsers that do not support createObjectURL
            return {
                success: false,
                message: "Your browser does not support this feature.",
            };
        }
    } catch (error) {
        console.error("Error fetching or processing data:", error);
        // Handle error as needed
        return {
            success: false,
            message: error,
        };
    }
};
